import {
    FetchState,
    ScheduledPersonalContributionState,
    ScheduledPersonalContribution
} from "@/shared/types";
import * as PayrollService from "@/shared/api/payrollService";
import * as storeHelper from "@/shared/storeHelper";
import { errorIsStatus } from "@/shared/errorHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";

export const initialState: ScheduledPersonalContributionState = {
    fetchState: FetchState.Uninitialized,
    scheduledPersonalContribution: null
};

export const useScheduledPersonalContributionStore = defineStore("scheduledPersonalContribution", {
    state: (): ScheduledPersonalContributionState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setScheduledPersonalContribution (
            scheduledPersonalContribution: ScheduledPersonalContribution) {
            this.scheduledPersonalContribution = scheduledPersonalContribution;
        },
        getScheduledPersonalContribution (): Promise<void> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);

            return PayrollService.getScheduledPersonalContribution().then(resp => {
                this.setScheduledPersonalContribution(resp.data);
                this.setFetchState(FetchState.Loaded);
            }).catch(err => {
                if (errorIsStatus(err, 404)) {
                    return;
                }

                storeHelper.handleError({ error: err, rethrow: false });
            }).finally(() => this.setFetchState(FetchState.Loaded));
        },
        saveScheduledPersonalContribution (
            request: ScheduledPersonalContribution): Promise<void> {
            this.setFetchState(FetchState.Loading);
            const notifierStore = useNotifierStore();
            return PayrollService.saveScheduledPersonalContribution(request).then(resp => {
                this.setScheduledPersonalContribution(resp.data);
                this.setFetchState(FetchState.Loaded);
                notifierStore.setSuccess("Your scheduled personal contribution has been saved.");
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: true });
            });
        }
    }
});